

const Joi = require('joi');
import { HOST } from "common-import/constants";
import { Request } from "common-import/helpers";
import * as Validator from "./User.Validator.js"

class UserAPI {


/*
undefinedPOST http://localhost:3000/users/register
Content-Type: application/json

{
    "email" : "trinhvietnambk@gmail.com",
    "password":"123123",
    "firstName":"Nam",
    "lastName":"Trịnh Viết",
    "type":["Contractor"]
}


*/    


  register = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/users/register", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }


/*




POST http://localhost:3000/users/login
Content-Type: application/json

{
    "email" : "trinhvietnambk@gmail.com",
    "password":"123123",
    "type":"normal"
}


*/    


  loginNormal = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/users/login", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }


/*


POST http://localhost:3000/users/login
Content-Type: application/json

{
    "accessToken":"EAACEdEose0cBAKmoYqRLNyQmroCw6ixCWZCQxVbRQEE6KnVmLxbVymyswiHKQdZBwcqLWZB4aFdyevoP5ElGzL9ZA2sk1Vt6v65tbScxlAolYLWF3ZCadb6Bw3CqtorE1e9LsGdoT3mVAQZCEJXh4bfJr9Gt9M5oBgRCKZAE1EaoZC5OqHqWnv30H2MZAt63y3BYZD",
    "type":"facebook"
}


*/    


  login = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/users/login", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }


/*


POST http://localhost:3000/users/login
Content-Type: application/json

{
  "accessToken": "ya29.GluDBfA4O9yVBYIL-gwIpJ9fLFdZKWTa_SNzGktzijdyVYiMj-OVcUHUxYPdLr9zlxp_oMfm2uc9HJpPbjoIS27ElQ8-3Os2nM8OsKx8TQFHVWn0ElT7Nj2rXRGL",
  "idToken": "eyJhbGciOiJSUzI1NiIsImtpZCI6ImM2ZjBlZTE2YmU3MGM0ODhkZDM5ZGI3MGY2ZjRkMTM3YTA0ODkxZTMifQ.eyJhenAiOiI0MDc0MDg3MTgxOTIuYXBwcy5nb29nbGV1c2VyY29udGVudC5jb20iLCJhdWQiOiI0MDc0MDg3MTgxOTIuYXBwcy5nb29nbGV1c2VyY29udGVudC5jb20iLCJzdWIiOiIxMTI3Njk1MTM0MjAwNzAyNTgzODMiLCJoZCI6ImhvdXNlbGluay5pbmZvIiwiZW1haWwiOiJuYW0udHZAaG91c2VsaW5rLmluZm8iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiYXRfaGFzaCI6IlAwWHAwTDl2YTRQQ2N3TWNkME16Y0EiLCJleHAiOjE1MjE0ODM1MjgsImlzcyI6Imh0dHBzOi8vYWNjb3VudHMuZ29vZ2xlLmNvbSIsImlhdCI6MTUyMTQ3OTkyOH0.G1TlvOM7jQi6gJG4PsIKT9WanPy5MghaKmI0SbbAynRjqHrvlQoPwN_AD-0Uyu8pQi2X9t9w8sduC-c9mArFUNOqYMbUdcMPKU0nLGYN60ATwY0_k8hSvCYmt5onlb-5vWgLW8AQoaI5xhoBgd8nCLEivxm84eXsIZ1bPM10SijmpHi6_DMKfl-9lFzL1b1oT8F8YPQevb_9r-Byxy_nDyAmJ8SSfQKq_KZLzQEZGqjTQWnzPuyQG1QBvIFVyPmPYa8eOKODQlH-tJpSgvErPU_ow4fpoKY2th0DKI88WsdsIw-yO5OkM3D6wNPk1VYfCoMMH5hWy-p6s7ezT3DYSQ",
  "type":"google"
}


*/    


  login = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/users/login", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }


/*



POST http://localhost:3000/users/update
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNjUxMDgzMjcxMzkifQ.afBEkYoJPy0OlLsdpaPu3-_P-4RSTBaTDYHN_YOUT60

{
  "phone":"0165 605 3482"
}


*/    


  update = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/users/update", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }


/*




POST http://localhost:3000/users/changePassword
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI4MjYwNzk0NDg3NjUifQ.btQcpTPJfdOFGbsaxgKGWR31yIVKoWMtfqiaKt6As-E

{
  "password":"123123",
  "newPassword":"abcd123"
}


*/    


  changePassword = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/users/changePassword", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }


/*


GET http://api.houselink.com:3000/users/me
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjMyMzQ1NDMyNDN9.8btzWCnIHktAby5Z851tJo-95ytYYEk55LUSdgynEao

{

}

*/    


  me = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.get(HOST + "/users/me", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }

  detail = async (userId) => {
    const validator = false; // change this to real vuserId
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.get(HOST + "/users/detail/"+userId, {});
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }


/*


POST http://localhost:3000/users/logout
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI3Njc1MTQ2MTkyMTMifQ.S4E5fMlOqtw9qoz-4M8IfiKCMJrXRIPHVqEMgU3F95c

{

}

*/    


  logout = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/users/logout", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }


/*



POST http://localhost:3000/users/projects
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI5OTgzNDM2NDA3ODMiLCJjcmVhdGVkQXQiOjE1MjE1OTE1Nzc5MzF9.NXhGQulhldhAxJTswJSJ_GTpokgxjLFZLU2Bmk-XeJw

{
    "page":1
}

*/    


  projects = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/users/projects", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }


/*





POST http://localhost:3000/users/myFavoriteFollowing
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI5OTgzNDM2NDA3ODMiLCJjcmVhdGVkQXQiOjE1MjE1OTE1Nzc5MzF9.NXhGQulhldhAxJTswJSJ_GTpokgxjLFZLU2Bmk-XeJw

{
    "page":1
}

*/    


  myFavoriteFollowing = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/users/myFavoriteFollowing", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }


/*



*/

  adminList = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/users/adminList", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }


}
export default new UserAPI();



// WEBPACK FOOTER //
// ./src/services/user/User.API.js